import { render, staticRenderFns } from "./PageMainSleeping.vue?vue&type=template&id=92235a66&"
import script from "./PageMainSleeping.vue?vue&type=script&lang=js&"
export * from "./PageMainSleeping.vue?vue&type=script&lang=js&"
import style0 from "./PageMainSleeping.vue?vue&type=style&index=0&id=92235a66&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports